"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageLoginSettings = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsLoginSettings = require("../../components/DmsLoginSettings/DmsLoginSettings");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageLoginSettings Component
 * 
 * @description This component renders the Login Settings page. It displays the DmsPage layout with a DmsAltBox component containing the DmsLoginSettings component.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageLoginSettings />
 * )
 * 
 * @returns {JSX.Element} The Login Settings page.
 */
const DmsPageLoginSettings = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Login Settings"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("LoginSettings").d("Login Settings"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsLoginSettings.DmsLoginSettings, null))));
};
exports.DmsPageLoginSettings = DmsPageLoginSettings;